<!-- @format -->
<script>
  import { getStoresContext } from "~/stores";
  export let request_store_key;

  const { store } = getStoresContext(request_store_key);
  
  let images;
  $: { 
    if ($store?.images && $store?.images.length > 1) images =  $store?.images.slice(1);
    if ($store?.tenantImages && $store?.tenantImages.length >= 1 ) {
      $store?.tenantImages.forEach(function (item) {
        images.push(item.url)
      });
    }
  }

</script>

{#if images}
  <div class="store-img">
    {#each images as item}
      <div class="img-wrap">
        <img src={item} alt={store.name} />
      </div>
    {/each}
  </div>
{:else}
  <div class="store-padding" />
{/if}

<style lang="scss">
  .store-img {
    display: flex;
    flex-wrap: wrap;
    padding: 20px 10px;
  }
  .img-wrap {
    position: relative;
    width: 100%;
    padding-top: 60%;
    img {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
      border-radius: 20px;
      padding: 10px;
    }
  }
  .store-padding {
    padding-top: 150px;
  }
  @media screen and (min-width: 768px) {
    .store-img {
      padding: 20px;
    }
  }

  @media screen and (min-width: 992px) {
    .store-img {
      padding: 80px 70px 20px 70px;
    }
    .img-wrap {
      width: 50%;
      padding-top: 30%;
    }
  }
</style>
